// ============================================================================
// The /dailys egg form's four default group names
// ============================================================================
//
// Four strings, and they are PERSISTED DATA rather than presentation: whatever
// the four selects hold at submit time is written to egg_dailys.group1_name ..
// group4_name. On production the fourth default is 'Retirement Home', a group
// that is NOT in the form's own option list (that list is derived from
// layer_batches / layer_housings) and that still lands on about one report a
// day because it is the default. So this derivation is behaviour, not styling,
// and it is worth its own module.
//
// LIFTED VERBATIM out of WebformHub, and deliberately not improved on the way.
// It was `(layerGroups || []).filter((g) => g.status === 'active')` followed by
// four `activeLayerGroups[i]?.name || ''` reads inside the EMPTY_E literal.
// Same filter, same order, same `|| ''`, same absence of any array check — a
// non-array still throws here exactly as it threw there, because normalizing it
// is the READ owner's job (layer.eggDailys.groups does it) and swallowing it
// here would hide a malformed blob instead of the surface's own owner handling
// it.
//
// It moved so that it could be BOUND to a proof. The blob it reads used to
// arrive on App's global boot, resolved before the presenter's first render,
// and now arrives from a scoped query that has not resolved on that frame. That
// is exactly the kind of move that silently changes a persisted value, so
// tests/static/webform_hub_egg_group_defaults_static.test.js drives this
// function together with the real catalog query over a named corpus and asserts
// the four values against a baseline generated from the ORIGINAL code before
// any of it changed. A copy of this logic inside the test would have proved
// nothing.
// ============================================================================

// STATUS RESOLUTION MOVED, THE SHAPE OF THIS FUNCTION DID NOT.
//
// `(layerGroups || []).filter((g) => g.status === 'active')` is now
// `filterActiveLayerGroups(layerGroups)`, which is the same filter over the
// same array in the same order, with two properties this file cannot own
// alone: a legacy/absent/unknown status resolves to inactive (only `active` is
// eligible, and it was already the only literal tested for), and duplicate rows
// carrying one name fail closed. A non-array argument still throws exactly as
// it did — see that function's own note.
import {filterActiveLayerGroups} from '../lib/layerGroupStatus.js';

/** One `ppp-layer-groups-v1` row, reduced to the two fields this reads. */
export type EggGroupCandidate = {name?: string; status?: string};

/**
 * The four group names the egg form starts on, in blob order, from the ACTIVE
 * rows only. Always length 4: absent positions are `''`, which is what the
 * select renders as the blank option and what `submitEgg` turns back into
 * `null`.
 */
export function eggGroupNameDefaults(layerGroups: readonly EggGroupCandidate[] | null | undefined): string[] {
  const activeLayerGroups = filterActiveLayerGroups(layerGroups);
  return [
    activeLayerGroups[0]?.name || '',
    activeLayerGroups[1]?.name || '',
    activeLayerGroups[2]?.name || '',
    activeLayerGroups[3]?.name || '',
  ];
}
